<!-- 团队介绍页面 -->
<template>
  <div class="team-container">
    <img class="img-top" src="../../assets/img/团队介绍-顶图.webp" alt="" />
    <div class="team-content">
      <div class="section-header">
        <h2 class="section-title">{{ $i18n.locale === 'zh' ? '核心团队' : 'Core Team' }}</h2>
        <p class="section-subtitle">{{ $i18n.locale === 'zh' ? '专业、高效、创新的技术团队' : 'Professional, Efficient & Innovative Technical Team' }}</p>
      </div>
      <div class="team-grid">
        <div
          class="team-card"
          v-for="(role, i) in $t('team.roles')"
          :key="i"
        >
          <div class="card-accent"></div>
          <div class="card-index">{{ String(i + 1).padStart(2, '0') }}</div>
          <h3 class="card-title">{{ role.title }}</h3>
          <p class="card-desc">{{ role.desc }}</p>
        </div>
      </div>
    </div>
    <div class="team-footer">
      <div class="footer-inner">
        <p>{{ $i18n.locale === 'zh' ? '加入我们，共创未来' : 'Join us and shape the future together' }}</p>
        <a
          target="_blank"
          href="https://www.zhaopin.com/companydetail/%E6%AD%A6%E6%B1%89%E7%A6%8F%E5%8D%A1%E8%BF%AA%E6%B1%BD%E8%BD%A6%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8_CC194600711.htm"
          class="footer-btn"
        >{{ $t('nav.recruit') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t('team.seoTitle'),
      meta: [
        {
          name: "description",
          content: this.$t('team.seoDescription'),
        },
        {
          name: "keywords",
          content: this.$t('team.seoKeywords'),
        },
      ],
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.team-container {
  width: 100%;
  min-width: auto;
  height: auto;
  background-color: #f8f9fc;

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  .img-top {
    width: 100%;
    height: auto;
    display: block;
  }

  .team-content {
    max-width: 1150px;
    width: 100%;
    padding: 60px 20px;
    margin: 0 auto;

    @media (max-width: 768px) {
      padding: 40px 16px;
    }
  }

  .section-header {
    text-align: center;
    margin-bottom: 50px;

    @media (max-width: 768px) {
      margin-bottom: 30px;
    }
  }

  .section-title {
    font-size: 36px;
    color: #1a1a1a;
    margin: 0 0 12px;
    position: relative;
    display: inline-block;

    &::after {
      content: '';
      display: block;
      width: 60px;
      height: 3px;
      background: #d53434;
      margin: 10px auto 0;
      border-radius: 2px;
    }

    .lang-en & {
      font-size: 30px;
    }

    @media (max-width: 768px) {
      font-size: 26px;
      .lang-en & {
        font-size: 22px;
      }
    }
  }

  .section-subtitle {
    font-size: 16px;
    color: #888;
    margin: 0;

    .lang-en & {
      font-size: 14px;
    }

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .team-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  .team-card {
    background: #fff;
    border-radius: 12px;
    padding: 30px 24px 24px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    }

    @media (max-width: 768px) {
      padding: 20px 16px;
    }
  }

  .card-accent {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #d53434, #ff6b6b);
  }

  .card-index {
    font-size: 42px;
    font-weight: 800;
    color: #f0f0f0;
    position: absolute;
    top: 12px;
    right: 16px;
    line-height: 1;

    @media (max-width: 768px) {
      font-size: 32px;
      top: 8px;
      right: 12px;
    }
  }

  .card-title {
    font-size: 20px;
    color: #1a1a1a;
    margin: 0 0 14px;
    padding-right: 50px;
    line-height: 1.4;

    .lang-en & {
      font-size: 17px;
    }

    @media (max-width: 768px) {
      font-size: 17px;
      padding-right: 40px;
      .lang-en & {
        font-size: 15px;
      }
    }
  }

  .card-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    margin: 0;

    .lang-en & {
      font-size: 13px;
      line-height: 1.6;
    }

    @media (max-width: 768px) {
      font-size: 13px;
      line-height: 1.7;
      .lang-en & {
        font-size: 12px;
      }
    }
  }

  .team-footer {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    padding: 50px 20px;
    text-align: center;

    @media (max-width: 768px) {
      padding: 36px 16px;
    }
  }

  .footer-inner {
    max-width: 600px;
    margin: 0 auto;

    p {
      color: #ccc;
      font-size: 18px;
      margin: 0 0 24px;

      .lang-en & {
        font-size: 16px;
      }

      @media (max-width: 768px) {
        font-size: 15px;
      }
    }
  }

  .footer-btn {
    display: inline-block;
    padding: 12px 40px;
    background: #d53434;
    color: #fff;
    border-radius: 30px;
    font-size: 16px;
    text-decoration: none;
    transition: background 0.3s, transform 0.2s;

    &:hover {
      background: #b71c1c;
      transform: scale(1.03);
    }

    @media (max-width: 768px) {
      padding: 10px 32px;
      font-size: 14px;
    }
  }
}
</style>
